import { IndexModel } from "../Support/IndexModel";
export class UserIndex extends IndexModel {
    endpoint = 'user';
    filters = { 'with-trashed': 1 };
    getData() {
        return super.getData();
    }
}
